import React, { useMemo } from 'react';
import { pick } from 'ramda';
import { Control } from '../Control';
import { withField } from '../withField';
import { I18n } from 'js/components/common/I18n';

import { CheckboxShallow } from './components/CheckboxShallow';

import style from './Checkbox.scss';

// todo checkbox group (with rff)
// todo checkbox HOC with positive/negative values (much later - for reg builder)

export const CheckboxBare = ({
    /* rff render props */
    input,
    meta = {},

    /* user provided props */
    id,
    name,
    label,
    labelTop,
    hint,
    hintTop,
    className = '',
    classNames: classNamesProps,
    onClick,
    itemRef,
    isLabelAsteriskEnabled,

    ...checkboxDomProps
}) => {
    const classNames = useMemo(
        () => ({ ...classNamesProps, ...pick(['content', 'hint'], style) }),
        [classNamesProps]
    );

    const labelTopContent = typeof labelTop === 'string'
        ? <I18n tKey={labelTop} defaultValue={labelTop} />
        : labelTop;

    return (
        <Control
            id={id}
            meta={meta}
            onClick={onClick}
            label={labelTopContent}
            hint={hintTop}
            animate={true}
            classNames={classNames}
            className={`${className} ${style.control}`}
        >
            <CheckboxShallow
                id={id}
                label={label}
                hint={hint}
                name={name}
                itemRef={itemRef}
                classNames={classNames}
                {...input}
                {...checkboxDomProps}
                {...meta.submitting ? { disabled: true } : {}}
                isLabelAsteriskEnabled={isLabelAsteriskEnabled}
            />
        </Control>
    );
};

export const withCheckbox = Wrapped => props => <Wrapped {...{
    ...props,
    type: 'checkbox' // it is required for rff `Field` to know how to unpack `value`
}} />;

export const Checkbox = withCheckbox(withField(CheckboxBare));
